import { createReducer } from "redux-create-reducer";

import { CREATE_WATCH_LIST_ENTRY } from "../types";

const initialState = {
  isLoading: false,
};

const createWatchListEntryReducer = createReducer(initialState, {
  [CREATE_WATCH_LIST_ENTRY.DEFAULT]: (state) => ({
    ...state,
    isLoading: true,
  }),
  [CREATE_WATCH_LIST_ENTRY.PENDING]: (state) => ({
    ...state,
    isLoading: true,
  }),
  [CREATE_WATCH_LIST_ENTRY.REJECTED]: (state) => ({
    ...state,
    isLoading: false,
  }),
  [CREATE_WATCH_LIST_ENTRY.FULFILLED]: (state) => ({
    ...state,
    isLoading: false,
  }),
});

export default createWatchListEntryReducer;



// WEBPACK FOOTER //
// ./src/features/watch-list-entry/reducers/createWatchListEntryReducer.js